import { Pipe, PipeTransform } from '@angular/core';
import { LevelEnum } from '@evasys/globals/shared/enums/business/level.enum';
import { SystemInfoService, TranslateService } from '@evasys/evasys/shared/core';
import { map, Observable } from 'rxjs';
import { EvasysLoadingStrategiesEnum } from '@evasys/globals/shared/enums/general/evasys-loadingStrategies.enum';

@Pipe({
	name: 'translateLevel',
})
export class TranslateLevelPipe implements PipeTransform {
	private readonly levelToLangKeyMap: Map<number, string> = new Map([
		[LevelEnum.DEAN, 'S_USER_DEAN'],
		[LevelEnum.ADMINISTRATOR, 'S_ADMINISTRATOR'],
		[LevelEnum.DEAN_OF_STUDIES, 'S_USER_DEANOFSTUDY'],
		[LevelEnum.DATA_COLLECTOR, 'S_USER_DATAENTRYASSISTANT'],
		[LevelEnum.SERIES_PRINT, 'S_MERGE_PRINT'],
		[LevelEnum.REPORT_CREATOR, 'S_USER_REPORTCREATOR'],
		[LevelEnum.WEB_VERIFIER, 'S_NUTZER_VERIFICATOR'],
		[LevelEnum.REPORTING_MASK, 'S_REPORT_MASK'],
		[LevelEnum.SUBSECTION_ADMINISTRATOR, 'S_NUTZER_SUBUNITADMIN'],
		[LevelEnum.MODUL, 'S_MODULE'],
		[LevelEnum.SOAP, 'S_SOAP_USER'],
		[LevelEnum.ARCHIVED, 'S_ARCHIVE'],
	]);

	public constructor(
		private readonly translateService: TranslateService,
		private readonly systemInfoService: SystemInfoService
	) {}

	transform(value: LevelEnum): Observable<string | null> {
		return this.systemInfoService.getOne('is_evaexam', EvasysLoadingStrategiesEnum.STATEFALLBACKAPI).pipe(
			map((systemInfo) => {
				const evaexam = systemInfo?.value;

				let langKey = this.levelToLangKeyMap.get(value);

				if (!langKey && value === LevelEnum.INSTRUCTOR) {
					langKey = evaexam ? 'S_USER_EXAMINER' : 'S_USER_INSTRUCTOR';
				}

				return langKey ? this.translateService.translate(langKey) : null;
			})
		);
	}
}
